export default __webpack_public_path__ + "static/dacs07-67f7f5b80e547280ab18841f166ceb32.jpg";